import * as React from 'react';
import { Provider } from 'react-redux';
import store from '@state/store';
import { OpenFacetsButton } from '../Components/OpenFacetsButton/OpenFacetsButton';
import type { OpenFacetsButtonData } from '../Components/OpenFacetsButton/OpenFacetsButton';

export const ProvideOpenFacetsButton = (props: OpenFacetsButtonData) => {
  return (
    <Provider store={store}>
      <OpenFacetsButton { ...props }/>
    </Provider>
  );
};
